import { Link } from 'react-router-dom';
import PopupScroll from '../common//PopupScroll';
import '../landingPageStyles.css';

const LandingPage = () => {

  const formattedText = (text) => {
    const words = text?.trim().split(" ");
    if (words.length === 2) {
      return (
        <>
          {words[0]}
          <br />
          {words[1]}
        </>
      );
    }
    return text;
  };

  return (

  <>  
  <div className="background"></div>
  <div className="content-wrapper">
    <div className="content" id="landing-page">

      <PopupScroll>
      <div className="main-section">
          <h1>Outplan</h1> 
          <h4 style={{color: 'white', marginTop: "2rem", marginBottom: "2rem"}}>Smart project planning that <b 
          style={{color: '#68AB88'}}>maximizes</b> team efficiency <b 
          style={{color: '#68AB88'}}>without overloading</b> your resources.</h4>
          <div className='btn-group-custom-landing-page' style={{margin: '2rem 0rem', gap: '1rem'}}>
          <Link to="/plans">
            <button className='btn-custom-landing-page green bold larger'>Choose Your Plan</button> 
          </Link>
          <Link to="/login">
          <button className='btn-custom-landing-page transparent larger'>Log In</button> 
          </Link>
          </div>
      </div>
      </PopupScroll>

      <div className='section bg'>
      <PopupScroll>
        <div className='subsection m-0 p-0'>
          <h1>{formattedText("Effort-Based Allocation")}</h1>
          <p>Optimize your project planning with smart, team-aware resource 
            allocation that balances efficiency and workload. With our embedded database models 
            reposurce allocation is more clear for understanding, setting up the goals with feasible targets 
            and reasonable timelines.
          </p>
        </div>
        </PopupScroll>
      </div>

      <div className="grid-container">
        <PopupScroll>
        <div className="item bg-top-left border-item-top-left-custom">
          <div className="item-content">
          <h2>{formattedText("Overload Detection")}</h2>
          <p>Spot resource overuse before it becomes a problem.</p>
          </div>
        </div>
        </PopupScroll>

        <PopupScroll>
        <div className="item bg-top-right border-item-top-right-custom">
          <div className="item-content">
          <h2>{formattedText("Smart Scheduling")}</h2>
          <p>Takes into account each team’s monthly capacity and effort distribution per project.</p>
          </div>
        </div>
        </PopupScroll>

        <PopupScroll>
        <div className="item bg-bottom-left border-item-bottom-left-custom">
          <div className="item-content">
          <h2>{formattedText("Conflict Detection")}</h2>
          <p>Instantly highlights over-allocated teams so you can adjust or prioritize smarter.</p>
          </div>
        </div>
        </PopupScroll>

        <PopupScroll>
        <div className="item bg-bottom-right border-item-bottom-right-custom">
          <div className="item-content">
          <h2>{formattedText("Simulation Driven")}</h2>
          <p>Compares multiple allocation options and picks the best one.</p>
          </div>
        </div>
        </PopupScroll>
      </div>

      <PopupScroll>
        <div className='small-section transparent'>
        <h2>Ready to start?</h2>
        <p>Start today with a <a
        className="dash-underlined-href" href="/plans">Free Plan</a>. Cancel any time you want.</p>
        <Link to="/plans">
          <button className='btn-custom-landing-page green bold'>Choose Your Plan</button> 
        </Link>
      </div>
      </PopupScroll>

      <PopupScroll>
      <div className="footer-container">
      <Link to="/home" className="footer">Home</Link>
      <div className='vertical-line'></div>
      <Link to="/terms" className="footer">Terms</Link>
      <div className='vertical-line'></div>
      <Link to="/privacy" className="footer">Privacy</Link>
      </div>
      </PopupScroll>

      <div style={{paddingBottom: "1rem", paddingTop: "1rem"}}>
      <p className="copyright">&copy; 2025 Luminicent Design Oy. All rights reserved.</p>
      </div>

    </div>
  </div></>

  );
}

export default LandingPage;